module.exports = __webpack_public_path__ + "img/6.d03598d1.png";